import { OrderPredictionResponse } from '@/gen/api';
import { OrderPrediction, OrderPredictionAlgorithm } from '@/models/OrderPrediction';
import { OrderPredictionItem } from '@/models/OrderPredictionItem';

export const toOrderPrediction = (response: OrderPredictionResponse): OrderPrediction => {
  const items: OrderPredictionItem[] = response.items.map((item) => {
    return {
      predictionId: response.predictionId,
      skuId: item.skuId,
      supplierId: item.supplierId,
      predictedSales: item.predictedSales,
      currentStock: item.currentStock,
      minimumStock: item.minimumStock,
      inTransit: item.inTransit,
    };
  });

  return {
    id: response.predictionId,
    date: response.targetDate,
    storeId: response.storeId,
    targetDate: response.targetDate,
    deliveryDate: response.deliveryDate,
    historyEndDate: response.historyEndDate,
    items: items,
  };
};

const allowedAlgorithms: OrderPredictionAlgorithm[] = ['simple_reorder'];

export const toOrderPredictionAlgorithm = (
  algorithm: string,
): OrderPredictionAlgorithm | undefined => {
  return allowedAlgorithms.includes(algorithm as OrderPredictionAlgorithm)
    ? (algorithm as OrderPredictionAlgorithm)
    : undefined;
};
